module.exports = __webpack_public_path__ + "static/media/news.1f3cace7.svg";